import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import { Progress, InfoCard } from '@backstage/core-components';
import { GitlabCIApiRef } from '../../../api/GitlabCIApi.esm.js';
import '../../utils.esm.js';
import 'dayjs';
import { useApi } from '@backstage/core-plugin-api';
import { useAsync } from 'react-use';
import { gitlabProjectId, gitlabProjectSlug, gitlabInstance, gitlabCodeOwnerPath } from '../../gitlabAppData.esm.js';
import { PeopleList } from './components/PeopleList/PeopleList.esm.js';
import { Divider } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  infoCard: {
    marginBottom: theme.spacing(3),
    "& + .MuiAlert-root": {
      marginTop: theme.spacing(3)
    }
  },
  subTitle: {
    marginTop: theme.spacing(0)
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));
const PeopleCard = (props) => {
  var _a, _b;
  const classes = useStyles();
  const project_id = gitlabProjectId();
  const project_slug = gitlabProjectSlug();
  const gitlab_instance = gitlabInstance();
  const codeowners_path = gitlabCodeOwnerPath();
  const GitlabCIAPI = useApi(GitlabCIApiRef).build(
    gitlab_instance || "gitlab.com"
  );
  const { value, loading, error } = useAsync(async () => {
    const projectDetails = await GitlabCIAPI.getProjectDetails(
      project_slug || project_id
    );
    if (!projectDetails)
      throw new Error("wrong project_slug or project_id");
    const contributorData = await GitlabCIAPI.getContributorsSummary(
      projectDetails.id
    );
    let codeOwners = [];
    try {
      codeOwners = await GitlabCIAPI.getCodeOwners(
        projectDetails.id,
        projectDetails == null ? void 0 : projectDetails.default_branch,
        codeowners_path
      );
    } catch (error2) {
      codeOwners = void 0;
    }
    return {
      contributors: contributorData,
      owners: codeOwners,
      projectDetails
    };
  }, []);
  const project_web_url = (_a = value == null ? void 0 : value.projectDetails) == null ? void 0 : _a.web_url;
  const project_default_branch = (_b = value == null ? void 0 : value.projectDetails) == null ? void 0 : _b.default_branch;
  let contributorsDeepLink;
  let ownersDeepLink;
  if (project_web_url && project_default_branch) {
    const contributorsLink = GitlabCIAPI.getContributorsLink(
      project_web_url,
      project_default_branch
    );
    contributorsDeepLink = {
      link: contributorsLink,
      title: "go to Contributors",
      onClick: (e) => {
        e.preventDefault();
        window.open(contributorsLink);
      }
    };
    const ownersLink = GitlabCIAPI.getOwnersLink(
      project_web_url,
      project_default_branch,
      codeowners_path
    );
    ownersDeepLink = {
      link: ownersLink,
      title: "go to Owners File",
      onClick: (e) => {
        e.preventDefault();
        window.open(ownersLink);
      }
    };
  }
  if (loading) {
    return /* @__PURE__ */ React.createElement(Progress, null);
  } else if (error) {
    return /* @__PURE__ */ React.createElement(Alert, { severity: "error", className: classes.infoCard }, error.message);
  }
  return /* @__PURE__ */ React.createElement(
    InfoCard,
    {
      title: "People",
      className: classes.infoCard,
      variant: props.variant
    },
    (value == null ? void 0 : value.owners) && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      PeopleList,
      {
        title: "Owners",
        peopleObj: value == null ? void 0 : value.owners,
        deepLink: ownersDeepLink
      }
    ), /* @__PURE__ */ React.createElement(Divider, { className: classes.divider })),
    /* @__PURE__ */ React.createElement(
      PeopleList,
      {
        title: "Contributors",
        peopleObj: (value == null ? void 0 : value.contributors) || [],
        deepLink: contributorsDeepLink
      }
    )
  );
};

export { PeopleCard };
//# sourceMappingURL=PeopleCard.esm.js.map
